"use strict";
function getSalary(item) {
    return parseInt(item.dataset.salary.replace(/\D/g, ""), 10);
}
function getEmployees(list) {
    var items = Array.from(list.children);
    var employees = [];
    for(var i = 0; i < items.length; i++){
        var item = items[i];
        employees.push({
            name: item.dataset.name,
            position: item.dataset.position,
            salary: getSalary(item),
            age: parseInt(item.dataset.age, 10)
        });
    }
    return employees;
}
function sortList(list) {
    var items = Array.from(list.children);
    items.sort(function(a, b) {
        var salaryA = getSalary(a);
        var salaryB = getSalary(b);
        return salaryB - salaryA;
    });
    items.forEach(function(item) {
        return list.appendChild(item);
    });
}
var employeeList = document.querySelector("ul");
sortList(employeeList);
getEmployees(employeeList);

//# sourceMappingURL=index.796a6a65.js.map
